export const itemRefurbStepRoutes = {
  searchItemRefurbSteps: {
    path: "/warehouse/item-refurb-steps/search",
    name: "searchItemRefurbSteps",
  },
  itemRefurbStepsCompleted: {
    path: "item-refurb-steps/completed",
    name: "itemRefurbStepsCompleted",
  },
  item: {
    path: "items/:itemId",
  },
  itemRefurbSteps: {
    path: "item-refurb-steps",
    name: "itemRefurbSteps",
  },
  itemRefurbStep: {
    path: "item-refurb-steps/:itemRefurbStepId",
    name: "itemRefurbStep",
  },
};
